import React from "react";
import { Grid, Divider, Typography, Box } from "@mui/material";
import styles from "../assets/styles/main.module.css";
import AppIcons from "../utils/appIcons";
import Strings from "../utils/stringUtil";
import theme from "../utils/themeUtil";
import { Link, useLocation } from "react-router-dom";
import constants from "../utils/constantsUtil";
import { isMobile } from "../utils/responsiveUtil";
import Routes from "../utils/routesUtil";
import Disclaimer from "./aditi/disclaimer";

function Footer() {
  const location = useLocation();
  const isBusinessLoanPage = location.pathname === Routes.MAHILA_LOAN;

  return (
    <Box position={"relative"} bgcolor={theme.palette.white.main} mt={5} pt={4}>
      <div className={styles.container}>
        <Grid pr={2} container spacing={2}>
          <Grid item xs={4} md={6} style={{ textAlign: "left" }}>
            <Link to={Routes.HOME} className={styles.navbarLink}>
              <img
                src={AppIcons.imgLogo}
                alt={Strings.mahilaMoney}
                style={{ width: isMobile ? "80px" : "120px", height: "auto" }}
              />
            </Link>
          </Grid>

          <Grid item xs={8} md={6}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Typography style={{ fontSize: isMobile ? "14px" : "16px" }}>
                {" "}
                {Strings.readyGetStarted}
              </Typography>
              <Link
                to={constants.mmPlayStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={AppIcons.imgDownloadApp}
                  alt={Strings.mahilaMoney}
                  style={{
                    width: isMobile ? "80px" : "140px",
                    height: "auto",
                    marginLeft: "16px",
                  }}
                />
              </Link>
            </div>
          </Grid>
        </Grid>

        <Divider variant="middle" style={{ margin: "20px 0px" }} />

        <Grid px={2} container spacing={2}>
          <Grid item xs={12} md={6} style={{ textAlign: "left" }}>
            <h4 style={{ color: theme.palette.primary.main }}>
              {Strings.products}
            </h4>

            <div style={{ display: "grid" }}>
              <Link to={Routes.MAHILA_LOAN} className={styles.footerLink}>
                {Strings.applyForLoan}
              </Link>
            </div>
          </Grid>

          <Grid item xs={12} md={6} style={{ textAlign: "left" }}>
            <h4 style={{ color: theme.palette.primary.main }}>
              {Strings.help}
            </h4>
            <div className={styles.footerLinks}>
              <Link
                to={Routes.FREQUENTLY_ASKED_QUESTIONS}
                className={styles.footerLink}
              >
                {Strings.faqs}
              </Link>
              <Link
                to={Routes.COMMUNITY_GUIDELINES}
                className={styles.footerLink}
              >
                {Strings.communityGuidelines}
              </Link>

              <Link to={Routes.PRIVACY_POLICY} className={styles.footerLink}>
                {Strings.privacyPolicy}
              </Link>
              <Link to={Routes.COOKIE_POLICY} className={styles.footerLink}>
                {Strings.cookiePolicy}
              </Link>
              <Link to={Routes.GRIEVANCE_POLICY} className={styles.footerLink}>
                {Strings.grievancePolicy}
              </Link>
              <Link to={Routes.TERMS_CONDITIONS} className={styles.footerLink}>
                {Strings.termsConditions}
              </Link>
              <Link to={Routes.CONTACT_US} className={styles.footerLink}>
                {Strings.contactUs}
              </Link>
            </div>
          </Grid>
        </Grid>

        <Grid px={2} container spacing={2}>
          <Grid item xs={12} md={6} style={{ textAlign: "left" }}>
            <h5 style={{ color: theme.palette.secondary.main }}>
              {Strings.followMahilaMoneyOn}
            </h5>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Link
                to={constants.mmLinkedInUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={AppIcons.imgLinkedin}
                  alt={Strings.linkedin}
                  style={{ width: "30px", height: "auto", marginRight: "16px" }}
                />
              </Link>
              <Link
                to={constants.mmTwitterUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={AppIcons.imgTwitter}
                  alt={Strings.linkedin}
                  style={{ width: "30px", height: "auto", marginRight: "16px" }}
                />
              </Link>
              <Link
                to={constants.mmInstagramUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={AppIcons.imgInstagram}
                  alt={Strings.linkedin}
                  style={{ width: "30px", height: "auto", marginRight: "16px" }}
                />
              </Link>
              <Link
                to={constants.mmFbUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={AppIcons.imgFacebook}
                  alt={Strings.linkedin}
                  style={{ width: "15px", height: "auto", marginRight: "16px" }}
                />
              </Link>
              {/* <Link
                to={constants.mmSheroesUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={AppIcons.imgSheroes}
                  alt={Strings.linkedin}
                  style={{ width: "30px", height: "auto", marginRight: "16px" }}
                />
              </Link> */}
            </div>
          </Grid>

          <Grid item xs={12} md={6} style={{ textAlign: "left" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: isMobile ? "start" : "end",
                marginTop: isMobile ? "4px" : "70px",
              }}
            >
              <img
                src={AppIcons.imgIndiumLogo}
                alt={Strings.indium}
                style={{
                  width: "140px",
                  height: "auto",
                  marginRight: "16px",
                }}
              />
              <img
                src={AppIcons.imgPartnerCapitalTrade}
                alt={Strings.partnerCapitalTrade}
                style={{ width: "140px", height: "auto" }}
              />
            </div>
          </Grid>
        </Grid>

        {isBusinessLoanPage && (
          <Grid container>
            <Disclaimer disclaimerText={Strings.businessLoanDisclaimer} />
          </Grid>
        )}

        <Grid container>
          <Grid item xs={12} md={12} style={{ textAlign: "center" }}>
            <h6
              style={{ color: theme.palette.grey.main, fontWeight: "normal" }}
            >
              {Strings.copyright}
            </h6>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
}

export default Footer;
